import { render, staticRenderFns } from "./BlankBoard.vue?vue&type=template&id=66d0f1f8"
import script from "./BlankBoard.vue?vue&type=script&lang=js"
export * from "./BlankBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports